module.exports = __webpack_public_path__ + "img/nodocs.734b3117.svg";